import React, { Fragment } from 'react';
import {
  Button,
  Header,
  Dropdown,
  Segment,
  Table,
  Grid,
} from 'semantic-ui-react';
import FilterModal from './FilterModal.jsx';
import Confirmation from '../Confirmation.jsx';
import {
  EnhancedDropdown,
  EnhancedHeaderContent,
} from '../defaultClassComponents.jsx';
import useToggle from '../hooks/useToggle.jsx';

export default function IndexRow(props) {
  const toggleCreateModal = useToggle(false);
  const toggleDeleteModal = useToggle(false);

  return (
    <Fragment>
      <Grid
        padded
        as={Table.Row}
      >
        <Grid.Row
          as={Table.Cell}
          className='RQLTableRow'
          onClick={() =>
            Turbolinks.visit(`${props.link}?filter_id=${props.filter.id}`)
          }
        >
          <Grid.Column width={11}>
            <Header as='h4'>
              <EnhancedHeaderContent>
                {props.filter.name}
                <Header.Subheader content={props.filter.description} />
              </EnhancedHeaderContent>
            </Header>
          </Grid.Column>

          <Grid.Column width={5}>
            <Button.Group floated='right'>
              <EnhancedDropdown
                basic
                button
                closeOnBlur
                compact
                floating
                className='icon'
                floated='right'
                icon='bars'
              >
                <Dropdown.Menu>
                  {props.canUpdateFilter ? (
                    <Dropdown.Item
                      content='Edit Name/Description'
                      icon='edit'
                      onClick={toggleCreateModal.toggle}
                    />
                  ) : null}
                  {props.canDestroyFilter ? (
                    <Dropdown.Item
                      content='Delete'
                      icon='trash'
                      onClick={toggleDeleteModal.toggle}
                    />
                  ) : null}
                </Dropdown.Menu>
              </EnhancedDropdown>
            </Button.Group>
          </Grid.Column>

          <Segment
            inverted
            className={'RQLQuerySegment'}
            floated='right'
          >
            <code>{props.filter.query}</code>
          </Segment>
        </Grid.Row>
      </Grid>

      <FilterModal
        close={toggleCreateModal.setFalse}
        filter={props.filter}
        isOpen={toggleCreateModal.value}
        onSave={props.onSave}
      />

      <Confirmation
        method='DELETE'
        msg={
          <span>
            Would you like to delete the filter:{' '}
            <strong>{props.filter.name}</strong>?
          </span>
        }
        newURL={`/${currentCustomer}/filters/`}
        path={`/${currentCustomer}/filters/${props.filter.id}`}
        show={toggleDeleteModal.value}
        size={'tiny'}
        title={'Delete Saved Filter'}
        onClose={toggleDeleteModal.setFalse}
      />
    </Fragment>
  );
}
